import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseChartDirective, Label } from 'ng2-charts';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { AuthStates } from '../../model/authorization';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'status-counter-chart',
  templateUrl: './status-counter-chart.component.html',
  styleUrls: ['./status-counter-chart.component.css']
})
export class StatusCounterChartComponent implements OnInit {

  @Input()
  public dateChartLabels: any[] = [];

  @Input()
  public countChartData: any[] = [];

  @Input()
  public loadingChartData: boolean;

  @Input()
  public changeTypeChart: ChartType;

  public spinner: boolean;

  public containsAccessData: boolean;

  public chartType: ChartType = 'doughnut';

  public donutColors=[
    {
      backgroundColor: []
    }
  ];

  public chartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      labels: {
        fontColor: 'black'
      }
    },
    tooltips: {
      callbacks: {
        footer: (context) => {
          //console.log(context)
          return `Total de autorizações: ${this.countChartData[1]}`
        },
        afterFooter: (context) => {
          let totalAuth = this.countChartData[1];
          let totalItem = 0;
          let label = '';
          let percent = 0;

          for (let i in this.countChartData[0]){
            if (context[0].index == parseInt(i)){
              totalItem = this.countChartData[0][i];
              label = this.dateChartLabels[0][i];
            }
          }
          percent = ((totalItem / totalAuth) * 100);
          return `${percent.toString().substr(0, 4)}% ${label}`
        }
      }
    }
  };

  public chartData: ChartDataSets[] = [
    { data: [], 
      label: 'Status',
      fill: true,
    },
  ];
  public chartLabels: Label[] = [];

  @ViewChild(BaseChartDirective)
  public chart: any;

  constructor(private translate: TranslateService){}

  ngOnInit(): void {
  }
  
  ngOnChanges(){
    this.chartLabels = []
    this.chartData[0].data = this.countChartData[0];
    this.chartType = this.changeTypeChart;
    this.spinner = this.loadingChartData;

    if(this.dateChartLabels.length != 0){
      this.dateChartLabels[0].forEach((label: any) =>{
       if (label == AuthStates.WaitingUpdate){
        this.chartLabels.push(this.translate.instant("DASHBOARD.PAGE.STATUS_COUNTER.IN_ANALYSIS"));
        this.donutColors[0].backgroundColor.push('rgba(255, 170, 0)');
       }
       if (label == AuthStates.Ok){
        this.chartLabels.push(this.translate.instant("DASHBOARD.PAGE.STATUS_COUNTER.APPROVED"));
        this.donutColors[0].backgroundColor.push('rgba(129, 199, 111)');
       }
       if (label == AuthStates.Fail){
        this.chartLabels.push(this.translate.instant("DASHBOARD.PAGE.STATUS_COUNTER.FAIL"));
        this.donutColors[0].backgroundColor.push('rgba(255, 0, 0 )');
       }
      });
    }

    if(this.countChartData.length != 0){
      this.containsAccessData = true;
    }else{
      this.containsAccessData = false;
    }
  }

  ngAfterViewInit(){}
}
